<template>
  <div class="card-data-item">
    <p class="card-data-item-title">
      {{ title }}
    </p>
    <p class="card-data-item-value">
      {{ value }}
    </p>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.card-data-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  box-sizing: border-box;
  padding-top: 8px;
  p {
    font-size: $span-font-size;
    line-height: 20px;
    word-wrap: break-word;
  }
  p.card-data-item-title {
    width: 140px;
    color: $color-stage4;
    text-align: left;
  }
  p.card-data-item-value {
    width: 175px;
    color: $color-text;
    text-align: right;
  }
}
</style>
